<template>
  <v-dialog v-model="dialog.show" persistent max-width="500">
    <v-card>
      <v-card-title class="pl-0 pr-0 pt-0 ml-0 mr-0 mt-0">
        <v-toolbar :color="this.getAppBarColor">
          <v-toolbar-title>
            <v-row dense justify="center" align="center">
              <v-col cols="12">
                <span class="align-center">
                  <p class="white--text">{{ dialog.title }}</p>
                </span>
              </v-col>
            </v-row>
          </v-toolbar-title>
        </v-toolbar>
      </v-card-title>

      <v-card-text>
        <v-form ref="form">
          <v-row dense>
            <v-col cols="12" md="12" v-if="!dialog.edit">
              <SelectEmpresa2
                :multiple="true"
                @onChanged="empresa = $event"
                @onEmpresas="filtro.empresas = $event"
              />
            </v-col>
            <v-col cols="12" md="12">
              <v-select label="Papel" v-model="form.papel" :items="['Vendedor', 'Supervisor']"></v-select>
            </v-col>
            <v-col cols="12" md="12">
              <v-text-field
                v-model="form.faixaInadimplencia1"
                label="Faixa de Inadimplência 1"
                type="number"
                :rules="[rules.required, rules.isNumber]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="12">
              <v-text-field
                v-model="form.faixaInadimplencia2"
                label="Faixa de Inadimplência 2"
                type="number"
                :rules="[rules.required, rules.isNumber]"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="blue darken-1"
          small
          dark
          rounded
          depressed
          @click="dialog.edit != true ? save() : edit()"
        >Salvar</v-btn>

        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="red darken-2"
          small
          dark
          rounded
          depressed
          @click="close()"
        >Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import rules from "@/utils/rules";
import Inadimplencia from "@/services/inadimplencia";
export default {
  name: "DialogFormInadimplencia",

  components: {
    SelectEmpresa2: () => import("@/components/select/SelectEmpresa2")
  },

  data() {
    return {
      serviceInadimplencia: new Inadimplencia(),
      rules,
      filtro: {
        empresas: []
      },
      empresa: {},
      form: {
        dataCriacao: null,
        empresa: "",
        apelido: "",
        papel: "",
        faixaInadimplencia1: 0,
        faixaInadimplencia2: 0
      },
      dialog: {
        title: "",
        show: false,
        edit: false
      }
    };
  },

  methods: {
    show(edit, inadimplencia) {
      if (edit) {
        this.editInadimplencia(inadimplencia);
      } else {
        this.form.dataCriacao = new Date();
        this.dialog.title = "Nova Faixa de Inadimplência";
      }
      this.dialog.edit = edit;
      this.dialog.show = true;
    },

    editInadimplencia(inadimplencia) {
      this.dialog.title = "Editar Faixa de Inadimplência";
      this.form = { ...inadimplencia };
    },

    async save() {
      try {
        if (this.$refs.form.validate()) {
          this.form.empresa = this.empresa.cnpj;
          this.form.apelido = this.empresa.apelido;
          this.convertValuesToInt();
          let newProduto = await this.serviceInadimplencia.create(this.form);
          this.$toast.success(`Faixa de inadimpência criada com sucesso.`);
          this.$emit("created", newProduto);
          this.close();
        }
        return Promise.resolve();
      } catch (error) {
        this.$toast.error(error);
        return Promise.reject(error);
      }
    },

    async edit() {
      try {
        if (this.$refs.form.validate()) {
          const form = { ...this.form };
          this.convertValuesToInt();
          await this.serviceInadimplencia.update(this.form.id, this.form);
          this.$toast.success(`Faixa de inadimpência atualizada com sucesso.`);
          this.$emit("updated", [{ ...this.form }, form.id]);
          this.close();
        }
        return Promise.resolve();
      } catch (error) {
        this.$toast.error(error);
        return Promise.reject(error);
      }
    },

    convertValuesToInt() {
      this.form.faixaInadimplencia1 = parseInt(this.form.faixaInadimplencia1);
      this.form.faixaInadimplencia2 = parseInt(this.form.faixaInadimplencia2);
    },

    close() {
      this.dialog.show = false;
      this.$refs.form.resetValidation();
      this.$refs.form.reset();
    }
  }
};
</script>

<style>
</style>